module.exports = __webpack_public_path__ + "img/3e79b219fc902fca7372cee5d4f630b0.png";